//@flow

import {
  LOAD_VIDEOS_DETAILS,
  LOAD_VIDEOS_DETAILS_SUCCESS,
  LOAD_VIDEOS_DETAILS_FAIL,
  LOAD_VIDEO_TRACK,
  LOAD_VIDEO_TRACK_SUCCESS,
  LOAD_VIDEO_TRACK_FAIL,
  SET_SELECTED_VIDEO_INDEX,
  VIDEOS,
  VIDEO_TRACK,
  DELETE_VIDEO,
  DELETE_VIDEO_SUCCESS,
  DELETE_VIDEO_FAIL,
  CLEAR_ERROR,
  SET_STREAM_TRANSMITING,
} from './../types/video';
import type { VideoMetaData, VideoAction } from './../types/video';

export const loadVideosDetails = (axiosInstance: any, id: number, source: string): VideoAction => ({
  type: LOAD_VIDEOS_DETAILS,
  id,
  axiosInstance,
  source,
});

export const loadVideosDetailsSuccess = (videos: Array<VideoMetaData>): VideoAction => ({
  type: LOAD_VIDEOS_DETAILS_SUCCESS,
  [VIDEOS]: videos
});

export const loadVideosDetailsFail = (error: string): VideoAction => ({
  type: LOAD_VIDEOS_DETAILS_FAIL,
  error
});

export const loadVideoTrack = (axiosInstance: any, videoId: number): VideoAction => ({
  type: LOAD_VIDEO_TRACK,
  videoId,
  axiosInstance
});

export const loadVideoTrackSuccess = (videoTrack: Array<VideoMetaData>): VideoAction => ({
  type: LOAD_VIDEO_TRACK_SUCCESS,
  [VIDEO_TRACK]: videoTrack
});

export const loadVideoTrackFail = (error: string): VideoAction => ({
  type: LOAD_VIDEO_TRACK_FAIL,
  error
});

export const setSelectedVideoIndex = (index: number | null) =>({
  type: SET_SELECTED_VIDEO_INDEX,
  index
});

export const deleteVideo = (axiosInstance: any, id: number) =>({
  type: DELETE_VIDEO,
  axiosInstance,
  id
});

export const deleteVideoSucess = (id: number)=>({
  type: DELETE_VIDEO_SUCCESS,
  id
});

export const deleteVideoFail = (error: string)=>({
  type: DELETE_VIDEO_FAIL,
  error
});

export const clearError = (error: string)=>({
  type: CLEAR_ERROR,
});

export const setStreamTransmiting = (isStreamTransmiting: boolean, hlsUrl: string)=>({
  type: SET_STREAM_TRANSMITING,
  isStreamTransmiting,
  hlsUrl,
})


// WEBPACK FOOTER //
// ./src/actions/video.jsx